import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {PortfolioAsset} from '../models/portfolio-asset';
import {PortfolioOfftake} from '../models/portfolio-offtake';
import {PortfolioVersion} from '../models/portfolio-version';
import {PriceDataset} from '../models/price-dataset';
import {SimulationResult} from '../models/simulation-result';

export const PortfolioSimulatorActions = createActionGroup({
  source: 'Portfolio Simulator',
  events: {
    'Init': emptyProps(),
    'Update Inputs': props<{
      version?: string;
      provider?: string;
      priceDataset?: string;
      weatherYear?: string;
    }>(),
    'Load Assets Success': props<{assets: PortfolioAsset[]; version: string}>(),
    'Load Assets Failure': props<{error: string}>(),
    'Load Offtakes Success': props<{
      offtakes: PortfolioOfftake[];
      version: string;
    }>(),
    'Load Offtakes Failure': props<{error: string}>(),
    'Load Versions Success': props<{versions: PortfolioVersion[]}>(),
    'Load Versions Failure': props<{error: string}>(),
    'Load Price Datasets Success': props<{priceDatasets: PriceDataset[]}>(),
    'Load Price Datasets Failure': props<{error: string}>(),
    'Display Results': emptyProps(),
    'Load Simulation Results Success': props<{results: SimulationResult[]}>(),
    'Load Simulation Results Failure': props<{error: string}>(),
  },
});
